import React from 'react';
import ReactDOM from 'react-dom';
import styles from './modals.module.css';

export const EditImageModal = ({
  isOpen,
  onClose,
  image,
  onRemoveBackground,
  processingImage,
  isLoading
}) => {
  if (!isOpen || !image) return null;

  return ReactDOM.createPortal(
    <div className={styles.editModalOverlay} onClick={onClose}>
      <div className={styles.editModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.editModalHeader}>
          <h3>Edit Image</h3>
          <button type="button" className={styles.editModalClose} onClick={onClose}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 9.4L22.6 8L16 14.6L9.4 8L8 9.4L14.6 16L8 22.6L9.4 24L16 17.4L22.6 24L24 22.6L17.4 16L24 9.4Z" fill="#505050"/>
            </svg>
          </button>
        </div>
        <div className={styles.editModalContent}>
          <div className={styles.editModalPreview}>
            <img src={image.previewUrl} alt="Preview" />
          </div>
          <div className={styles.editModalOptions}>
            <button
              type="button"
              className={styles.editOptionButton}
              onClick={onRemoveBackground}
              disabled={processingImage || isLoading}
            >
              {processingImage ? 'Processing...' : 'Remove Background'}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
